import type { SwingTimingData } from 'leaderboard/scripts/swing-path/types/globals'

export default function getPitcherType(row: SwingTimingData) {
    if (row.pitch_hand_type === 'R') {
        return 'RHP'
    }

    if (row.pitch_hand_type === 'L') {
        return 'LHP'
    }

    return ''
}
